import React from 'react';

interface NumberFormatterProps {
  value: number | null;
}

const NumberFormatterSinSeparador: React.FC<NumberFormatterProps> = ({ value }) => {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return null;
  }

  const formattedNumber = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

  // const formattedNumberWithSeparator = formattedNumber.replace(/,/g, '');

  return formattedNumber;
};

export default NumberFormatterSinSeparador;

export const getNumberFormatted = (value: number | null): string => {
  if (value === null) {
    return '';
  }

  const formattedNumber = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

  // const formattedNumberWithSeparator = formattedNumber.replace(/,/g, '');

  return formattedNumber;
};

export const getNumberFormatted3 = (value: number | null): string => {
  if (value === null) {
    return '';
  }

  const formattedNumber = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  }).format(value);

  // const formattedNumberWithSeparator = formattedNumber.replace(/,/g, '');

  return formattedNumber;
};

// export const quitarSeparadorDeString = (value: string | null): string => {
//   if (value === null) {
//     return '';
//   }

//   return value.replace(/,/g, '');
// };
